import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useAppSelector } from '@store';
import Frs from '../../components/balance/frs';

import cn from './balance.module.css';

const BalanceFrs = () => {
  const { values } = useAppSelector((state) => state.balance.frs);

  const { isLoading, errorList } = useOutletContext<{
    isLoading: boolean;
    errorList?: string;
  }>();

  useEffect(() => {
    let title = 'Balance FRS';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  return (
    <div className={cn.balanceFrs}>
      {errorList && (
        <div className={cn.reportsLoadingError}>
          <div className={cn.reportsLoadingErrorTitle}>Unable to load data</div>
          <div className={cn.reportsLoadingErrorText}>{errorList}</div>
        </div>
      )}
      {!errorList && <Frs frs={values} isLoading={isLoading} />}
    </div>
  );
};

export default BalanceFrs;
